import SchemaHandler from '@exp/exp-utils/schema/schemaHandler';
import { getPerformanceData } from '@tcc/shared/src/helpers/performance';

// Uncomment and set extends back to AbstractEventHandler to enable event bus
// import AbstractEventHandler from '../../csp/handlers/abstractEventHandler';
// import config from '@exp/exp-utils/helper/config';
// import { filterPerfSchemas, filterPerfDelayedSchemas } from '../../../utils/eventBusUtils';

class AddPagePerfHandler extends SchemaHandler {
  process() {
    super.process({
      EVENT_SVC: (input) => { this._handleEventSvc(input); }
    });
  }

  _handleEventSvc(input) {
    getPerformanceData('tcc', 'manual', input.custom_properties);
  }

  // Uncomment to enable event bus events
  // _getApiKey() {
  //   return config.get('tcc.eventBusRigorApiKey');
  // }

  // _getEvents(input) {
  //   if (input.properties && input.properties.navigationStart) {
  //     return [{
  //       schemaId: 'urn:shared:user:event:/rigor/page-view-load/v1',
  //       data: filterPerfSchemas(input.properties)
  //     }];
  //   }
  //   if (input.properties && input.properties.timeToInteractive) {
  //     return [{
  //       schemaId: 'urn:shared:user:event:/rigor/page-view-load-delayed/v1',
  //       data: filterPerfDelayedSchemas(input.properties)
  //     }];
  //   }
  // }
}

export default AddPagePerfHandler;
